/**
 * usePromotionCartCount — live size of the current user's promotion cart.
 *
 * Subscribes to `users/{uid}/promotionCart` and returns the count of items.
 * Shared by Header (badge) and PromotionStackPanel (Open-cart CTA).
 */
import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { firestore } from "../FirebaseConfig";

export default function usePromotionCartCount(uid) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!uid) {
      setCount(0);
      return undefined;
    }
    const ref = collection(firestore, "users", uid, "promotionCart");
    const unsub = onSnapshot(
      ref,
      (snap) => setCount(snap.size),
      () => setCount(0),
    );
    return () => unsub();
  }, [uid]);
  return count;
}
